// React imports
import React, { useState } from 'react';

// Generic imports
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// FontAwesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

// MUI imports
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';

// Local imports
import TimelineEditor from '../timeline/Timeline.editor.js';

function NoteEditor(props) {
    const { organization, accesstoken, conversationId, onNoteDone, onClose, noteId } = props;
    const [ type, setType ] = useState('personal');
    const [ uploading, setUploading ] = useState(false);
    const [ error, setError ] = useState(null);

    async function _onNoteDone({ html, tags, files }) {
        console.log('[NoteEditor] onNoteDone', html, tags, files);
        // Check for mentions in personal notes
        if (type === 'personal' && html.match(/@[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)) {
            setError('Cannot include mentions in personal notes. Please change to public note type if you want to mention others.');
            return;
        }
        try {
            const id = noteId || uuidv4();
            setError(null);
            setUploading(true);
            const { data: note } = await axios.put(`/api/emailconversations/${encodeURIComponent(conversationId)}/note/${id}?organizationId=${organization.id}&accesstoken=${accesstoken}`, { html, tags, files, type });
            setUploading(false);
            onNoteDone({ note });
        } catch (e) {
            setUploading(false);
            setError(e.message);
            console.log('[NoteEditor] error with note', e);
        }
    }

    return (
        <Box sx={{ background: 'rgba(96, 93, 228, 0.2)', p: 2, borderRadius: 1, position: 'relative' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Select
                    value={type}
                    onChange={e => setType(e.target.value)}
                    sx={{ fontSize: '11px', padding: '0px' }}
                    variant='standard'
                >
                    <MenuItem value='personal'>Personal Note</MenuItem>
                    <MenuItem value='public'>Public Note</MenuItem>
                </Select>
                <Typography variant='caption' sx={{ fontSize: '11px' }}>
                    {type === 'personal' ? 'Only you will be able to see this note.' : 'Everyone in your organization will be able to see this note.'}
                </Typography>
                <Box sx={{ flex: 1 }} />
                <IconButton onClick={() => onClose()}>
                    <FontAwesomeIcon icon={faTimes} />
                </IconButton>
            </Box>
            <TimelineEditor
                organization={organization}
                edit={true}
                initialUpdate={{}}
                onEdit={() => { }}
                onUpdateDone={_onNoteDone}
                onClose={() => { }}
                possibleUpdateTags={null}
                featureToggle={{}}
                opportunities={[]}
                tradelines={[]}
                noPadding={true}
            />
            {type === 'public' && (
                <Typography variant='caption' component='div' sx={{ fontSize: '11px', marginTop: '12px', fontStyle: 'italic' }}>
                    You can tag other users in your organization by typing their email address. However, only members that have access to this conversation will be able to see the note.
                </Typography>
            )}
            {error && (
                <Alert severity='error' sx={{ mt: 2 }}>{error}</Alert>
            )}
            {uploading && (
                <Box sx={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(0, 0, 0, 0.2)', borderRadius: 1 }}>
                    <CircularProgress />
                </Box>
            )}
        </Box>
    )
}

export default NoteEditor;